import { useDimValues } from '~/api/hooks/useDimValues'
import { CAMPAIGN_EXACT_DIM } from '~/state/campaignPredicate'
import type { ActiveCampaign } from '~/state/useCampaignState'

/** D-FEW-5: true iff the active campaign resolves EXACT on this fact (dim present) but the
 *  fact has no rows tagged with its id — the honest-empty is then "no rows of its own",
 *  not "filters matched nothing". Pending/error controls ⇒ false (generic notice; never a
 *  hold). Attribution-resolved campaigns (dim absent) ⇒ false: their empty IS filter-empty.
 *
 *  Final-review fix: `campaign.factCarriesCampaign` is resolved against the PAGE fact only
 *  (useCampaignState's own single-fact/ratio-pair rule) — a caller checking a DIFFERENT fact
 *  (a driver or compare arm) must pass THAT fact's own carrying flag as `factCarriesCampaign`,
 *  or a page fact that carries + an arm fact that doesn't (mixed carriage) wrongly fires the
 *  sharper notice on an arm that actually resolved by attribution. Defaults to
 *  `campaign?.factCarriesCampaign` so page-fact callers (incl. the ratio-page pair-rule value)
 *  stay byte-identical without threading a redundant 4th arg. */
export function useCampaignHasNoRows(
  campaign: ActiveCampaign | null | undefined,
  factTable: string,
  kpi: string,
  factCarriesCampaign: boolean = campaign?.factCarriesCampaign ?? false,
): boolean {
  const values = useDimValues(CAMPAIGN_EXACT_DIM, factTable, kpi)
  return Boolean(
    campaign &&
    factCarriesCampaign &&
    values.isSuccess &&
    !values.data.includes(campaign.item.value),
  )
}
